// AI Generated Component
import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'seo-issues-btn-group',
    templateUrl: './seo-issues-btn-group.component.html',
    standalone: false,
})
export class SeoIssuesBtnGroupComponent implements OnInit {
    @Input() count!: number;
    @Input() highestNo!: number;

    constructor () {}

    ngOnInit (): void {
        this.activate();
    }

    activate (): void {}

    btnGroupWidth (): string {
        return (this.count / this.highestNo * 100) + '%';
    }
}
